import React from 'react';
import ProtectedRoute from './ProtectedRoute';

export default function ProtectedSubscriptionRoute({ children }) {
  // Subscription check is now handled silently in the Homepage component
  // This route just provides authentication protection
  return <ProtectedRoute>{children}</ProtectedRoute>;
}